import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import styled from 'styled-components';

import { createApolloClient } from './utils/create-apollo-client';

import { MainGrid } from './components/main-grid';
import { MainHeader } from './components/main-header';

import { AboutContainer } from './containers/about';
import { IndexContainer } from './containers/index';

const Main = styled.main``;

export class App extends React.Component {
  public render() {
    return (
      <ApolloProvider client={createApolloClient()}>
        <Router>
          <Switch>
            <Main>
              <MainHeader />
              <MainGrid>    
                <Route path="/" exact={true} component={IndexContainer} />
                <Route path="/about" component={AboutContainer} />
              </MainGrid>
            </Main>
          </Switch>
        </Router>
      </ApolloProvider>
    );
  }
}




// WEBPACK FOOTER //
// ./src/app.tsx